function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.056 3.737c.009.162.012.326.012.49C17.068 9.231 13.148 15 5.977 15c-2.201 0-4.25-.627-5.977-1.701.304.033.615.053.93.053a7.97 7.97 0 004.842-1.622c-1.708-.029-3.146-1.125-3.643-2.63a4.004 4.004 0 001.76-.063C2.105 8.687.76 7.158.76 5.322v-.047a3.979 3.979 0 001.766.472C1.48 5.068.794 3.908.794 2.595c0-.693.192-1.343.528-1.902 1.92 2.29 4.794 3.797 8.035 3.955a3.647 3.647 0 01-.1-.863C9.257 1.695 11.002 0 13.154 0 14.276 0 15.289.46 16 1.194a7.92 7.92 0 002.476-.918 3.827 3.827 0 01-1.714 2.094A7.902 7.902 0 0019 1.774a7.71 7.71 0 01-1.944 1.963",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTwitter;